import axios from 'axios';

// IMPORTANT: These key values are duplicated in public/index.html (inline polling script).
// If you change them here, update index.html too.
const STORAGE_KEY_SID = 'sso_polling_sid';
const STORAGE_KEY_AST = 'sso_polling_authstate';

/**
 * Create a polling session on the backend and store the sid in localStorage.
 * Returns the sid on success, null on failure.
 * Failures are silently caught — the normal auth flow continues as fallback.
 */
export async function initPollingSession(authStateId, lang) {
  try {
    const body = { auth_state_id: authStateId };
    if (lang) {
      body.lang = lang;
    }
    const res = await axios.post(
      process.env.API_URL + '/signin/module.php/tmauth/polling/create',
      body,
    );
    const { sid } = res.data;
    localStorage.setItem(STORAGE_KEY_SID, sid);
    localStorage.setItem(STORAGE_KEY_AST, authStateId);
    return sid;
  } catch (e) {
    console.warn('Failed to create polling session', e);
    return null;
  }
}

/**
 * Clear polling session data from localStorage.
 */
export function clearPollingSession() {
  localStorage.removeItem(STORAGE_KEY_SID);
  localStorage.removeItem(STORAGE_KEY_AST);
}
